exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-date .vdp-datepicker__calendar-button{position:absolute;right:15px}", ""]);

// exports
